// extracted by mini-css-extract-plugin
module.exports = {"list":"_12652","actions":"_4607"};